import { render, staticRenderFns } from "./FormaRecebimentoModal.vue?vue&type=template&id=9ad22f70&scoped=true"
import script from "./FormaRecebimentoModal.vue?vue&type=script&lang=js"
export * from "./FormaRecebimentoModal.vue?vue&type=script&lang=js"
import style0 from "./FormaRecebimentoModal.vue?vue&type=style&index=0&id=9ad22f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad22f70",
  null
  
)

export default component.exports